import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';
import { useCallback } from 'react';
import { useUserAuth } from '../../../../contexts/auth';
import adminApi from '../../../../api/admin-api';
import { NewsArticle, UpdateNewsArticleInput } from '../types';
// import { NewsArticle, CreateNewsArticleInput, UpdateNewsArticleInput } from '../types';

export const useNewsArticles = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { strings } = useStringsContext();
  const { currentUser } = useUserAuth();

  const updateNewsArticle = useCallback(
    async (newsArticle: UpdateNewsArticleInput) => {
      try {
        const response = await adminApi.put({
          path: `/news/${newsArticle.id}`,
          auth: await currentUser?.getIdToken(),
          body: newsArticle,
        });
        if (!response.ok) {
          throw new Error(`Updating newsArticle failed! (${response.status})`);
        }
      } catch (error) {
        console.error(error);

        enqueueSnackbar(strings.messages.loadingError, {
          variant: 'error',
        });
      }
    },
    [enqueueSnackbar, strings, currentUser]
  );

  const fetchNewsArticles = useCallback(
    async (abbrv: string): Promise<NewsArticle[]> => {
      let newsArticles: NewsArticle[] = [];

      try {
        const response = await adminApi.get({
          path: `/news/${abbrv}`,
          auth: await currentUser?.getIdToken(),
        });

        if (response.status === 404) {
          return [];
        }

        if (!response.ok) {
          throw new Error(`Fetching newsArticles failed! (${response.status})`);
        }

        newsArticles = await response.json();
      } catch (error) {
        console.error(error);

        enqueueSnackbar(strings.messages.loadingError, {
          variant: 'error',
        });
      }

      return newsArticles;
    },
    [enqueueSnackbar, strings, currentUser]
  );

  return { fetchNewsArticles, updateNewsArticle };
};
